
import { useDispatch, useSelector} from "react-redux";
import { useDedupEffect } from "@npd-ng/adp-component-library";
import { IADPState } from "../typings";
import { environment, getOnlineServices } from "../util";
import { createFailureAction, createSetDateTimeCheck, createLaunchFailureAction } from "../state/reducer";
import TimeService from "../services/timeService";

export function useDateTimeValidation() {
  const dispatch = useDispatch();  
  const state = useSelector(
    (state: { rootState: IADPState }) => state.rootState
  ); 
  
  const validateDateTime = async ()=>{
    const configuration = state.appState.configuration;  
    if(state.sessionState.networkConnectionState === "Connected"){
      const onlineURL =`${environment.resolveApiDomain(configuration)}/${getOnlineServices(configuration)?.cloudServiceHealth}`;
      const timeInSync = await TimeService.validateCurrentTime(
        onlineURL,state?.appState.configuration?.systemClockThreshold || 300000);
      if(!timeInSync.passed){
        if(timeInSync.serverTime?.includes("ErrorFetchingDate")){
            dispatch(createLaunchFailureAction({error:"DateTimeError",errorDetails:{timeStamp: new Date(),errorMessage:`There was a network error trying to get the server date and time.`}}))
            dispatch(createFailureAction(navigator.onLine ? "NoServerConnectionDetected": "NoInternetConnectionDetected")); 
        }
        else {
            dispatch(createLaunchFailureAction({error:"DateTimeError",errorDetails:{timeStamp: new Date(),errorMessage:`The current Date and time are not matching the NAEP server date and time. Current Time: ${timeInSync.localTime}, Server Time:${timeInSync.serverTime}`}}))
            dispatch(createFailureAction("FailedSystemTimeCheck"));
        }
      }
            dispatch(createSetDateTimeCheck(true));    
      }
      else {
        dispatch(createFailureAction("NoInternetConnectionDetected"));
      }
  }  
  useDedupEffect(() => {
    if(state.appState.configuration && state.appState.resourcesLoaded){
      console.info("[DateTimeValidation]", "validate device date/time");
      validateDateTime();
    }
    },[state.appState.resourcesLoaded,state.appState.configuration]);
    return {validateDateTime}
  }


